import { Description, Dialog, DialogPanel, DialogTitle } from '@headlessui/react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/outline';

interface ConfirmDialogProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  title?: string;
  message?: string;
  cancelText?: string;
  confirmText?: string;
  variant?: 'default' | 'danger';
}

const ConfirmDialog = ({
  open,
  onCancel,
  onConfirm,
  title = 'Confirm',
  message = 'Are you sure you want to proceed?',
  cancelText = 'No',
  confirmText = 'Yes',
  variant = 'default',
}: ConfirmDialogProps) => {
  const handleConfirmClick = () => {
    onConfirm();
    onCancel();
  };

  const isDanger = variant === 'danger';

  return (
    <Dialog open={open} onClose={onCancel} className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen bg-black bg-opacity-50 px-4">
        <DialogPanel className="max-w-lg w-full bg-white rounded-lg shadow-lg">
          <DialogTitle className="flex items-center text-lg font-semibold text-gray-900 p-4">
            {isDanger && (
              <ExclamationTriangleIcon className="h-6 w-6 text-red-600 mr-2" aria-hidden="true" />
            )}
            {title}
          </DialogTitle>

          <div className="px-4 pb-4">
            <Description className="text-gray-700">{message}</Description>
            <div className="mt-4 flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
                onClick={onCancel}
              >
                {cancelText}
              </button>

              <button
                onClick={handleConfirmClick}
                className={`px-4 py-2 rounded text-white hover:opacity-90 ${
                  isDanger ? 'bg-red-600 hover:bg-red-700' : 'bg-blue-600 hover:bg-blue-700'
                }`}
              >
                {confirmText}
              </button>
            </div>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default ConfirmDialog;
